import { IContactForm } from "@types";
import axios from "axios";
import { API_URL } from "@helpers";

export const sendContactForm = (data: IContactForm) => {
    return axios.post(`${API_URL}/form`, data);
};
